import type {Component, Editor} from 'grapesjs';

export const OPTION_LIST_KEY_SEPARATOR = '|';
export const OPTION_LIST_SELECTION_SEPARATOR = ',';

export interface OptionListItem {
  /** Per-item CSS property. Falls back to the descriptor's `property` if absent. */
  property?: string;
  value: string;
  /** Accessible name (tooltip) for the list item. */
  name: string;
  classes: string;
  label?: string;
  /** Non-selectable items render but don't react to click. */
  selectable?: boolean;
  parentClasses?: string;
  callback: (component: Component, editor: Editor) => void;
}

export interface OptionListDescriptor {
  /** CSS property read for pre-selection state. */
  property: string;
  readValue?: (component: Component) => string;
  titleKey: string;
  list: readonly OptionListItem[];
  /** When true, items toggle independently (multi-select). */
  toggleable?: boolean;
  /** Item value pre-selected on mount when nothing is read back from CSS. Non-toggleable lists only. */
  defaults?: string;
}
